<h4 mat-dialog-title class="mb-2">{{ data.title }}</h4>
<button class="close close-icon" mat-button color="primary" (click)="dialogRef.close()">
  <mat-icon>close</mat-icon>
</button>
<div class="pt-0" mat-dialog-actions>
  <mat-form-field class="form-field text-field w-100 pt-0">
    <textarea
      matInput
      type="text"
      id="message"
      pattern="^[ A-Za-z0-9-_]*$"
      style="height: 173px; width: 80% !important"
      [(ngModel)]="message"
      [disabled]="this.data?.inputValue.isOwner == false"
      style="border: 1px solid #747474; height: 130px; border-radius: 3px; padding: 10px; width: 94% !important"
      >{{ message }}</textarea
    >

    <span *ngIf="messageRequired" style="color: red"> Content is required </span>
  </mat-form-field>
  <div style="display: contents">
    <div class="col-sm-12 pl-0">
      <label *ngIf="this.data?.inputValue.updatedDate">
        Last updated : {{ this.data?.inputValue.updatedDate | simpleDate }}</label
      >
    </div>
  </div>

  <div class="btn-head">
    <div class="text-left w-100 mt-3">
      <button
        class="btn-outline mb-3 text-left"
        mat-button
        color="primary"
        *ngIf="this.data?.inputValue.isOwner == true"
        (click)="deleteNotes()"
      >
        Delete
      </button>
    </div>
    <div class="text-right w-100 mt-3">
      <button
        class="btn-primary text-light mb-3"
        mat-button
        *ngIf="this.data?.inputValue.isOwner == true || !this.data?.inputValue._id"
        (click)="updateNotes()"
      >
        Save
      </button>
    </div>
  </div>
</div>
